(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1079,269,9676],{

/***/ 94184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 46442:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/x-black.6f461ee7.svg","height":15,"width":15});

/***/ }),

/***/ 45481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "App": function() { return /* reexport */ app_App; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/spinner/dist/chakra-ui-spinner.esm.js + 1 modules
var chakra_ui_spinner_esm = __webpack_require__(89238);
// EXTERNAL MODULE: ./node_modules/@the-volte/svc-core-sdk/lib/index.js
var lib = __webpack_require__(44859);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/components/atoms/index.ts + 6 modules
var atoms = __webpack_require__(23920);
// EXTERNAL MODULE: ./src/components/organisms/index.ts + 9 modules
var organisms = __webpack_require__(14254);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
// EXTERNAL MODULE: ./src/images/x-black.svg
var x_black = __webpack_require__(46442);
;// CONCATENATED MODULE: ./src/components/organisms/RedirectedFromBanner/index.tsx





var messages = {
    item: "Sorry that item is not available anymore",
    designers: "Sorry we don’t have that designer"
};
var removeQueryParam = function(param, router) {
    var pathname = router.pathname, query = router.query;
    var params = new URLSearchParams(query);
    params.delete(param);
    router.replace({
        pathname: pathname,
        query: params.toString()
    }, undefined, {
        shallow: true
    });
};
var RedirectedFromBanner = function(param) {
    var redirectedFrom = param.redirectedFrom;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
        w: "full",
        bgColor: "white",
        borderBottom: "1px",
        borderTop: "1px",
        paddingY: "4",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                mx: "auto",
                textAlign: "center",
                children: messages[redirectedFrom] || "sorry"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                    display: "flex",
                    justifyContent: "flex-end",
                    cursor: "pointer",
                    onClick: function() {
                        removeQueryParam("redirectedFrom", router);
                    },
                    position: "relative",
                    right: [
                        2,
                        null,
                        null,
                        20
                    ],
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_svg_esm/* ReactSVG */.Q, {
                        src: x_black/* default.src */.Z.src
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var organisms_RedirectedFromBanner = (RedirectedFromBanner);

;// CONCATENATED MODULE: ./src/components/organisms/SaleBanner/SaleBanner.tsx



var OverlayBox = function(param) {
    var overlay = param.overlay, children = param.children;
    return overlay ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
        position: "relative",
        width: "100%",
        top: "0",
        zIndex: 50,
        height: 0,
        children: children
    }) : children;
};
var SaleBanner = function(param) {
    var message = param.message, overlay = param.overlay;
    return message && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverlayBox, {
        overlay: overlay,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Center */.M5, {
            backgroundColor: "white",
            borderBottom: "1px",
            opacity: 0.95,
            height: [
                "70px",
                null,
                null,
                null,
                null,
                "40px"
            ],
            paddingX: "10px",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                align: "center",
                lineHeight: [
                    "30px",
                    null,
                    null,
                    null,
                    null,
                    "50px"
                ],
                fontSize: [
                    "18px",
                    null,
                    null,
                    null,
                    null,
                    "20px"
                ],
                children: message
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/SaleBanner/index.ts


// EXTERNAL MODULE: ./src/globalStyles/index.ts + 2 modules
var globalStyles = __webpack_require__(63319);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
;// CONCATENATED MODULE: ./src/components/organisms/UnconfirmedOrderBanner/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  @media (min-width: 768px) {\n    flex-direction: row;\n    padding-bottom: 5px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: underline;\n  padding-left: 5px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var UnConfirmedOrderBannerTextContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject());
var UnconfirmedOrderBannerLink = emotion_styled_browser_esm/* default.a */.Z.a(_templateObject1());

;// CONCATENATED MODULE: ./src/components/organisms/UnconfirmedOrderBanner/UnconfirmedOrderBanner.tsx





var UnconfirmedOrderBanner_OverlayBox = function(param) {
    var children = param.children, isSaleActive = param.isSaleActive, overlay = param.overlay;
    return overlay ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
        position: "relative",
        width: "100%",
        top: isSaleActive ? "42" : "0",
        zIndex: 50,
        height: 0,
        children: children
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
        position: "relative",
        width: "100%",
        top: "0",
        zIndex: 20,
        height: 0,
        children: children
    });
};
var UnconfirmedOrderBanner = function(param) {
    var overlay = param.overlay, total = param.total, isSaleActive = param.isSaleActive;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UnconfirmedOrderBanner_OverlayBox, {
        isSaleActive: isSaleActive,
        overlay: overlay,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Center */.M5, {
            backgroundColor: "white",
            borderBottom: "1px",
            opacity: 0.9,
            paddingY: "4",
            height: [
                "16",
                "12",
                "12"
            ],
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(UnConfirmedOrderBannerTextContainer, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                        color: globalStyles/* defaultTheme.colors.components.UnConfirmedOrderBanner.textColor */.uH.colors.components.UnConfirmedOrderBanner.textColor,
                        fontSize: [
                            "20",
                            "22",
                            "22"
                        ],
                        children: [
                            "You have",
                            " ",
                            total === 1 ? "an unconfirmed order." : "".concat(total, " unconfirmed orders.")
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                        color: globalStyles/* defaultTheme.colors.components.UnConfirmedOrderBanner.textColor */.uH.colors.components.UnConfirmedOrderBanner.textColor,
                        fontSize: [
                            "20",
                            "22",
                            "22"
                        ],
                        pl: 1,
                        children: [
                            "Please",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UnconfirmedOrderBannerLink, {
                                href: "/dashboard/orders",
                                target: "_blank",
                                children: "review and confirm now"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/UnconfirmedOrderBanner/index.ts


// EXTERNAL MODULE: ./src/hooks/useLocalStorage.tsx
var useLocalStorage = __webpack_require__(83319);
// EXTERNAL MODULE: ./src/hooks/useLogin.ts
var useLogin = __webpack_require__(67083);
// EXTERNAL MODULE: ./src/components/legacy/index.ts + 40 modules
var legacy = __webpack_require__(92291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/utils/menu.tsx
var menu = __webpack_require__(62075);
// EXTERNAL MODULE: ./src/components/legacy/MenuProvider/context.ts
var MenuProvider_context = __webpack_require__(14077);
;// CONCATENATED MODULE: ./src/components/legacy/MenuProvider/index.tsx






var MainMenuProvider = function(param) {
    var mainMenu = param.mainMenu, footer = param.footer, children = param.children, siteSetting = param.siteSetting;
    var ref;
    var ref1 = (0,react.useState)({
        mainMenu: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, MenuProvider_context/* defaultContext.mainMenu */.O.mainMenu, mainMenu), {
            items: (mainMenu === null || mainMenu === void 0 ? void 0 : mainMenu.items) ? (0,menu/* getMappedItems */.i)(mainMenu.items) : undefined
        }),
        footer: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, MenuProvider_context/* defaultContext.footer */.O.footer, footer), {
            items: (footer === null || footer === void 0 ? void 0 : footer.items) ? (0,menu/* getMappedItems */.i)(footer.items) : undefined
        }),
        siteSetting: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, MenuProvider_context/* defaultContext.siteSetting */.O.siteSetting), {
            socialMedia: (ref = siteSetting === null || siteSetting === void 0 ? void 0 : siteSetting.socialMedia) !== null && ref !== void 0 ? ref : []
        })
    }), context = ref1[0];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuProvider_context/* MenuContext.Provider */.p.Provider, {
        value: context,
        children: children
    });
};
/* harmony default export */ var MenuProvider = (MainMenuProvider);

// EXTERNAL MODULE: ./src/components/legacy/ShopProvider/context.ts
var ShopProvider_context = __webpack_require__(61888);
;// CONCATENATED MODULE: ./src/components/legacy/ShopProvider/index.tsx





var countryCodeToCurrency = {
    AU: "AUD",
    NZ: "NZD",
    GB: "GBP"
};
var countryCodeToDemonym = {
    AU: "Australian",
    NZ: "New Zealander",
    GB: "British"
};
var ShopProvider = function(param) {
    var shopConfig = param.shopConfig, shop = param.shop, children = param.children;
    var ref = (0,react.useState)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ShopProvider_context/* defaultContext */.O, shopConfig, shop), {
        currency: shopConfig && shopConfig.defaultCountry ? countryCodeToCurrency[shopConfig.defaultCountry.code] : "AUD",
        demonym: shopConfig && shopConfig.defaultCountry ? countryCodeToDemonym[shopConfig.defaultCountry.code] : "Australian"
    })), context = ref[0];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShopProvider_context/* ShopContext.Provider */.I.Provider, {
        value: context,
        children: children
    });
};
/* harmony default export */ var legacy_ShopProvider = (ShopProvider);

// EXTERNAL MODULE: ./src/intl-shim.tsx
var intl_shim = __webpack_require__(47355);
// EXTERNAL MODULE: ./node_modules/react-alert/dist/esm/react-alert.js + 2 modules
var react_alert = __webpack_require__(1519);
;// CONCATENATED MODULE: ./src/app/Notifications.tsx





var Notifications = function() {
    var alert = (0,react_alert.useAlert)();
    var intl = (0,intl_shim/* useIntl */.YB)();
    var authenticated = (0,lib.useAuth)().authenticated;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(), 2), prevAuthenticated = ref[0], setPrevAuthenticated = ref[1];
    react.useEffect(function() {
        if (prevAuthenticated !== undefined && authenticated !== undefined) {
            if (!prevAuthenticated && authenticated) {
                alert.show({
                    title: intl.formatMessage({
                        defaultMessage: "You are now signed in"
                    })
                }, {
                    type: "success"
                });
            } else if (prevAuthenticated && !authenticated) {
                alert.show({
                    title: intl.formatMessage({
                        defaultMessage: "You are now signed out"
                    })
                }, {
                    type: "success"
                });
            }
            setPrevAuthenticated(authenticated);
        } else if (authenticated !== undefined) {
            setPrevAuthenticated(authenticated);
        }
    }, [
        authenticated
    ]);
    return null;
};
/* harmony default export */ var app_Notifications = (Notifications);

;// CONCATENATED MODULE: ./src/app/App.tsx





















var App = function(param) {
    var mainMenu = param.mainMenu, shopConfig = param.shopConfig, children = param.children, shop = param.shop, footer = param.footer, siteSetting = param.siteSetting;
    var ref;
    var ref1 = (0,next_router.useRouter)(), pathname = ref1.pathname, query = ref1.query;
    var redirectedFrom = query.redirectedFrom;
    var ref2 = (0,lib.useAuth)(), user = ref2.user, externalLogout = ref2.externalLogout, loginByExternalPlugin = ref2.loginByExternalPlugin, verifyLogin = ref2.verifyLogin;
    var ref3 = (0,react.useState)((user === null || user === void 0 ? void 0 : (ref = user.lenderOrders) === null || ref === void 0 ? void 0 : ref.totalCount) || 0), totalUnconfirmedOrder = ref3[0], setTotalUnconfirmedOrder = ref3[1];
    var ref4 = (0,react.useState)(false), loading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,useLogin/* default */.Z)(), externalAuthPlugin = ref5.externalAuthPlugin, login = ref5.login;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useLocalStorage/* useLocalStorage */._)("authPlugin", undefined), 2), authPlugin = ref6[0], setAuthPlugin = ref6[1];
    var location = (constants/* ssrMode */.$m ? __webpack_require__.g : window).location;
    var handleExternalAuthentication = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, code, state, result, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        ref = query_string.parse(location.search), code = ref.code, state = ref.state;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            loginByExternalPlugin({
                                code: code,
                                state: state
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        // eslint-disable-next-line no-console
                        console.log(e);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        if (result) {
                            setAuthPlugin(externalAuthPlugin);
                        } else {
                            setAuthPlugin(undefined);
                        }
                        router_default().push(location.pathname);
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleExternalAuthentication() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (authPlugin && !user) {
            setLoading(true);
            setAuthPlugin(undefined);
            var verifyUserLogin = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    var result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    verifyLogin()
                                ];
                            case 1:
                                result = _state.sent();
                                setLoading(false);
                                if (!result) {
                                    setAuthPlugin(undefined); // user logged out - session expired
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function verifyUserLogin() {
                    return _ref.apply(this, arguments);
                };
            }();
            verifyUserLogin();
        }
    }, [
        authPlugin,
        user
    ]);
    (0,react.useEffect)(function() {
        var qs = query_string.parse(location.search);
        if ("session_state" in qs) {
            setLoading(true);
            handleExternalAuthentication();
        }
    }, [
        location.search
    ]);
    (0,react.useEffect)(function() {
        var ref;
        setTotalUnconfirmedOrder((user === null || user === void 0 ? void 0 : (ref = user.lenderOrders) === null || ref === void 0 ? void 0 : ref.totalCount) || 0);
    }, [
        user
    ]);
    var handleSignOut = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var payload, ref, _data, logoutData, logout_url;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setAuthPlugin(undefined);
                        payload = {
                            pluginId: externalAuthPlugin,
                            input: JSON.stringify({
                                returnTo: location.href
                            })
                        };
                        return [
                            4,
                            externalLogout(payload)
                        ];
                    case 1:
                        ref = _state.sent(), _data = ref.data, logoutData = _data.externalLogout.logoutData;
                        logout_url = JSON.parse(logoutData).logout_url;
                        location.href = logout_url;
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSignOut() {
            return _ref.apply(this, arguments);
        };
    }();
    var isPopup = pathname.startsWith("/popups");
    if (loading || authPlugin && !user) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
            h: "100%",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Center */.M5, {
                h: "100vh",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_spinner_esm/* Spinner */.$, {})
            })
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(legacy_ShopProvider, {
        shopConfig: shopConfig,
        shop: shop,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuProvider, {
            footer: footer,
            mainMenu: mainMenu,
            siteSetting: siteSetting,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(legacy.OverlayProvider, {
                pathname: pathname,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(legacy.MetaConsumer, {}),
                    !isPopup && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(legacy.MainMenu, {
                                handleSignOut: handleSignOut,
                                login: login,
                                loading: loading
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SaleBanner, {
                                overlay: false,
                                message: (shopConfig === null || shopConfig === void 0 ? void 0 : shopConfig.saleBannerMessage) || ""
                            }),
                            totalUnconfirmedOrder > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UnconfirmedOrderBanner, {
                                total: totalUnconfirmedOrder,
                                overlay: pathname === "/",
                                isSaleActive: !!(shopConfig === null || shopConfig === void 0 ? void 0 : shopConfig.saleBannerMessage)
                            }),
                            redirectedFrom && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms_RedirectedFromBanner, {
                                redirectedFrom: redirectedFrom
                            })
                        ]
                    }),
                    loading ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Loader, {
                        fullScreen: true
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.MainBodyWrapper, {
                        children: children
                    }),
                    !isPopup && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* Footer */.$_, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(legacy.OverlayManager, {
                                handleSignOut: handleSignOut,
                                login: login
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(app_Notifications, {})
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var app_App = (App);

;// CONCATENATED MODULE: ./src/app/index.ts



/***/ }),

/***/ 62075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ designerSlugSuffix; },
/* harmony export */   "i": function() { return /* binding */ getMappedItems; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


var getParentSlugs = function(items) {
    var result = {};
    var getSlug = function(item) {
        var ref, ref1;
        return ((ref = item.category) === null || ref === void 0 ? void 0 : ref.slug) || ((ref1 = item.page) === null || ref1 === void 0 ? void 0 : ref1.slug) || (item.parent ? "" : item.name.toLowerCase());
    };
    items.forEach(function(item) {
        var ref;
        item === null || item === void 0 ? void 0 : (ref = item.children) === null || ref === void 0 ? void 0 : ref.forEach(function(child) {
            var ref;
            result[child === null || child === void 0 ? void 0 : child.id] = {
                parentSlug: getSlug(item),
                parentName: item.name
            };
            child === null || child === void 0 ? void 0 : (ref = child.children) === null || ref === void 0 ? void 0 : ref.forEach(function(grandchild) {
                result[grandchild.id] = {
                    parentSlug: getSlug(child) || getSlug(item),
                    parentName: child === null || child === void 0 ? void 0 : child.name
                };
            });
        });
    });
    return result;
};
var designerSlugSuffix = "-hire";
var getUrlFromItem = function(item, parents) {
    var ref, ref1;
    var parentSlug = (ref = parents[item.id]) === null || ref === void 0 ? void 0 : ref.parentSlug;
    var parentName = (ref1 = parents[item.id]) === null || ref1 === void 0 ? void 0 : ref1.parentName.toLowerCase();
    if (item.category) {
        if (parentSlug) {
            return "/".concat(parentSlug, "/").concat(item.category.slug);
        }
        return "/category/".concat(item.category.slug);
    }
    if (item.collection) {
        return "/collection/".concat(item.collection.slug);
    }
    if (item.page) {
        var legacyPages = [
            "designers",
            "trends",
            "occasions",
            "size",
            "lengths"
        ];
        if (legacyPages.find(function(p) {
            var ref;
            return p === (item === null || item === void 0 ? void 0 : (ref = item.page) === null || ref === void 0 ? void 0 : ref.slug);
        })) {
            return "/".concat(item.page.slug);
        }
        if (parentSlug && legacyPages.find(function(p) {
            return p === parentSlug;
        })) {
            var pageParentSlug = parentSlug;
            var slugSuffix = pageParentSlug === "designers" ? designerSlugSuffix : "";
            // Special case for size
            if (parentSlug === "size") {
                pageParentSlug = "dresses";
            }
            return "/".concat(pageParentSlug, "/").concat(item.page.slug).concat(slugSuffix);
        }
        // Special cases for dresses
        if (parentSlug === "dresses") {
            if (parentName.startsWith("dress code")) {
                return "/occasions/".concat(item.page.slug);
            }
            if (parentName.startsWith("length")) {
                return "/lengths/".concat(item.page.slug);
            }
            if (parentName.startsWith("trend")) {
                return "/trends/".concat(item.page.slug);
            }
        }
        return "/".concat(item.page.slug);
    }
    return item.url;
};
var getMappedItems = function(items) {
    var parents = getParentSlugs(items);
    return items.map(function(item) {
        var ref;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, item), {
            legacyUrl: getUrlFromItem(item, parents),
            children: item === null || item === void 0 ? void 0 : (ref = item.children) === null || ref === void 0 ? void 0 : ref.map(function(child) {
                var ref;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, child), {
                    legacyUrl: getUrlFromItem(child, parents),
                    children: child === null || child === void 0 ? void 0 : (ref = child.children) === null || ref === void 0 ? void 0 : ref.map(function(grandchild) {
                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, grandchild), {
                            legacyUrl: getUrlFromItem(grandchild, parents)
                        });
                    })
                });
            })
        });
    });
};


/***/ }),

/***/ 25054:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/react-icons/lib/iconsManifest.mjs
var IconsManifest = [
  {
    "id": "ci",
    "name": "Circum Icons",
    "projectUrl": "https://circumicons.com/",
    "license": "MPL-2.0 license",
    "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
  },
  {
    "id": "fa",
    "name": "Font Awesome 5",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "fa6",
    "name": "Font Awesome 6",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "lu",
    "name": "Lucide",
    "projectUrl": "https://lucide.dev/",
    "license": "ISC",
    "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "hi2",
    "name": "Heroicons 2",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "sl",
    "name": "Simple Line Icons",
    "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "MIT",
    "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "tb",
    "name": "Tabler Icons",
    "projectUrl": "https://github.com/tabler/tabler-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "tfi",
    "name": "Themify Icons",
    "projectUrl": "https://github.com/lykmapipo/themify-icons",
    "license": "MIT",
    "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
  },
  {
    "id": "rx",
    "name": "Radix Icons",
    "projectUrl": "https://icons.radix-ui.com",
    "license": "MIT",
    "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
  },
  {
    "id": "pi",
    "name": "Phosphor Icons",
    "projectUrl": "https://github.com/phosphor-icons/core",
    "license": "MIT",
    "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
  },
  {
    "id": "lia",
    "name": "Icons8 Line Awesome",
    "projectUrl": "https://icons8.com/line-awesome",
    "license": "MIT",
    "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/iconContext.mjs

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && /*#__PURE__*/react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/iconBase.mjs
var _excluded = ["attr", "size", "title"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }


function Tree2Element(tree) {
  return tree && tree.map((node, i) => /*#__PURE__*/react.createElement(node.tag, _objectSpread({
    key: i
  }, node.attr), Tree2Element(node.child)));
}
function GenIcon(data) {
  // eslint-disable-next-line react/display-name
  return props => /*#__PURE__*/react.createElement(IconBase, _extends({
    attr: _objectSpread({}, data.attr)
  }, props), Tree2Element(data.child));
}
function IconBase(props) {
  var elem = conf => {
    var {
        attr,
        size,
        title
      } = props,
      svgProps = _objectWithoutProperties(props, _excluded);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return /*#__PURE__*/react.createElement("svg", _extends({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: _objectSpread(_objectSpread({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && /*#__PURE__*/react.createElement("title", null, title), props.children);
  };
  return IconContext !== undefined ? /*#__PURE__*/react.createElement(IconContext.Consumer, null, conf => elem(conf)) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/index.mjs




/***/ })

}]);